import { GetQcTaskMetadataParams } from './useGetQCTaskSubmissionQueries'

export const queryKeyFactory = {
  qcTaskMetadata: (params: GetQcTaskMetadataParams) => [
    'qcTask',
    'metadata',
    params.qc_task_id,
    params.study_id,
    params.is_previous_qc_task,
  ],
}
